import type { StreamingMessage } from "@storytell/streaming";
import type { AssetId } from "@storytell/types";
import { useWire } from "~/wire";

export const useMessageHasKnowledgeSearchAssets = () => {
  const wire = useWire();

  return (message: StreamingMessage | undefined) => {
    if (!message) return false;

    for (const o of message.operations) {
      const op = wire.stream.operation.get(o);
      if (op?.activity === "user_kb_search_v1") {
        for (const blockId of op.blocks) {
          const block = wire.stream.block.get(blockId);
          if (!block) continue;

          if (block.searchResults) {
            if (block.searchResults.results.case === "assets") {
              for (const asset of block.searchResults.results.value.assets) {
                return wire.sync.getAssetRelatedConcepts(asset.id as AssetId).length > 0;
              }
            }
          }
        }
      }
    }
    return false;
  };
};
